<div class="main">
  <div class="message">Something awesome will be here soon...</div>
</div>

